import { Protocol } from '../Protocol';

export class UnitProtocol {
  public static readonly ALL_Test_Unit: string = `${Protocol.YATUNG_API_ROOT}/expt/unit/all`; // 取得所有試驗單位
}
